import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/auth";

/**
 * Best-effort screenshot detection. Browsers cannot see or block OS-level
 * screen capture, so this only catches the Windows PrintScreen key (via
 * keyup — keydown doesn't fire for it in most browsers). It cannot detect
 * macOS shortcuts (Cmd+Shift+3/4/5), mobile screenshots, or a phone camera.
 * Treat this as an audit trail + deterrent, not real prevention.
 */
export function useScreenshotGuard(enabled) {
  const location = useLocation();

  useEffect(() => {
    if (!enabled) return;
    const onKeyUp = (e) => {
      if (e.key !== "PrintScreen") return;
      api.post("/screenshot-events", { page: location.pathname }).catch(() => {});
      toast.warning("Screenshot detected — this has been logged and reported to admins.");
    };
    window.addEventListener("keyup", onKeyUp);
    return () => window.removeEventListener("keyup", onKeyUp);
  }, [enabled, location.pathname]);
}
